import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { supabase } from '../../supabaseClient';
import './heroSlider.css';
import Banner1 from "../../assets/banner1.jpg";
import Banner2 from "../../assets/banner2.jpg";
import Banner3 from "../../assets/banner3.jpg";
import Banner4 from "../../assets/banner4.jpg";
import Banner5 from "../../assets/banner5.jpg";
import Banner6 from "../../assets/banner6.jpg";

const slideImages = [
  Banner1,
  Banner2,
  Banner3,
  Banner4,
  Banner5,
  Banner6
];

const HeroSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [bookingUrl, setBookingUrl] = useState("https://m.me/MufaTamDao");
  const { t } = useLanguage();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slideImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchBookingUrl = async () => {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('contact_info')
          .select('messenger_url')
          .eq('id', 1)
          .maybeSingle();

        if (error) throw error;
        if (data?.messenger_url) {
          setBookingUrl(data.messenger_url);
        }
      } catch (err) {
        console.error('Error fetching booking URL:', err);
      }
    };

    fetchBookingUrl();
  }, []);

  const handleRedirectBooking = () => {
    window.open(bookingUrl, "_blank");
  };

  return (
    <div className="hero-section">
      <div
        className="slider-track"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slideImages.map((image, index) => (
          <div
            key={index}
            className="slide-image"
            style={{ backgroundImage: `url(${image})` }}
          ></div>
        ))}
      </div>

      <div className="hero-overlay-dark"></div>

      <div className="hero-content">

        <div className="top-right-text">
          <h1 className="brand-serif">MUFA</h1>
          <h2 className="brand-script">tamdao</h2>
        </div>

        <div className="bottom-center-action">
          <button className="btn-booking" onClick={handleRedirectBooking}>{t('hero_booking')}</button>
          <p className="sub-text">{t('hero_subtext')}</p>
        </div>

      </div>
    </div>
  );
};

export default HeroSlider;